// import React, { useEffect, useRef, useState } from "react";
// import { Applogo, profileLogo } from "../../../Routes/ImagePath";
// import { DatePicker } from "antd";
// import { Radio } from "react-feather";
// import { useNavigate } from "react-router-dom";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import { ErrorToast, SuccessToast } from "../../ToastComponent";

// export const BTBankModal = ({BTBankDataVisitFunc}) => {
//   const initialTableData = [
//     {
//       module: "Projects",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Tasks",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Chat",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Estimates",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Invoices",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Timing Sheets",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//   ];

//   //   let yourDate = new Date()
//   // // yourDate.toISOString().split('T')[0]

//   // const today=(yourDate.toISOString().split('T')[0])

//   const [tableData, setTableData] = useState(initialTableData)

//   const fileInputRef = useRef(null);

//   // const [userId,setUserId] = useState('')

//   // useEffect(() => {
//   //  const id= JSON.parse(sessionStorage.getItem('user'))
//   // setUserId(id)
//   // }, [])

//   const AllFileLoginData = async () => {
//     try {
//       const id = JSON.parse(sessionStorage.getItem('user'))?.id
//       console.log("id", id)
//       const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       console.log("response", response)
//     } catch (error) {
//       return error
//     }
//   }

//   useEffect(() => {
//     AllFileLoginData()
//   }, [])

//   const [radioValue, setRadioValue] = useState(false);

//   // const [location, setLocation] = useState(null);

//   const [LocalFormData, setLocalFormData] = useState({

//     BranchId: Number,
//     Name: "",
//     Mobile: "",
//     // Purpose: Number,
//     IsPurposeMet: false,
//     ApplicationNo:"",
//     Selfie: null,
//     Latitude: "",
//     Longitude: "",
//   });

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setLocalFormData({ ...LocalFormData, Selfie: file });
//   };

//   const handleRadioChange = (e) => {
//     setRadioValue(e.target.value === 'true');

//   };

//   const handleDateChange = (date) => {
//     setLocalFormData({ ...LocalFormData, VisitDate: date });
//   };

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {

//         const { latitude, longitude } = position.coords;
//         setLocalFormData({ ...LocalFormData, Latitude: latitude, Longitude: longitude });
//       });
//     } else {
//       console.log("Geolocation is not supported by this browser.");
//     }
//   }, [])

//   // console.log("location",location?.latitude)

//   const HandleSubmit =async () => {

//     const formData = new FormData();
//     formData.append("BranchId", LocalFormData.BranchId);
//     formData.append("Name", LocalFormData.Name);
//     formData.append("Mobile", LocalFormData.Mobile);
//     // formData.append("Purpose", LocalFormData.Purpose);
//     formData.append("IsPurposeMet", LocalFormData.IsPurposeMet);
//     formData.append("ApplicationionNo", LocalFormData.ApplicationNo);
//     formData.append("Selfie", LocalFormData.Selfie);
//     formData.append("Latitude", LocalFormData.Latitude);
//     formData.append("Longitude", LocalFormData.Longitude);

//     if (LocalFormData.Mobile.length !== 10) {
//       ErrorToast("Mobile Number must be exactly 10 digits.");
//       return;
//     };
//     // console.log(LocalFormData)
//     try {
//       const response = await axios.post(`${Api_Url}api/v1/BTBankVisit`,formData,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//           "Content-Type": "multipart/form-data",
//         }
//       })
//       console.log(response)
//       BTBankDataVisitFunc()
//       resetForm()
//       SuccessToast("BTBank Submitted Successfully")
//     } catch (error) {
//       return error.message;
//     }
//   }

//   const resetForm = () => {
//     setLocalFormData({
//       BranchId: Number,
//       Name: "",
//       Mobile: "",
//       // Purpose: Number,
//       IsPurposeMet: false,
//       ApplicationNo:"",
//       Selfie: null,
//     });
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   };

//   const handleCheckboxChange = (module, column) => {
//     // Create a copy of the tableData
//     const updatedTableData = [...tableData];

//     // Find the row with the specified module
//     const row = updatedTableData.find((item) => item.module === module);

//     // Toggle the checkbox value
//     row[column] = !row[column];

//     // Set the updated data
//     setTableData(updatedTableData);
//   };

//   const [allbranch,setAllBranch] = useState('')

//   const AllBranchName=async () =>{
//     try {
//       const response = await axios.get(`${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       // console.log("response",response.data.data)
//       setAllBranch(response.data.data)
//     } catch (error) {
//       console.log("object",error)
//     }
//   }
//   console.log(allbranch)

//   useEffect(()=>{
//     AllBranchName()
//   },[])

//   const validateMobileNumber = (number) => {
//     const regex = /^[0-9]{0,10}$/;
//     return regex.test(number);
//   };

//   const handleMobileChange = (e) => {
//     const value = e.target.value;
//     if (validateMobileNumber(value)) {
//       setLocalFormData({
//         ...LocalFormData,
//         Mobile: value,
//       });
//     }}

//   return (
//     <>
//       <div id="add_client" className="modal custom-modal fade" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">BT Bank Visit</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="profile-image text-center mt-4 mb-4">
//                 <img
//                   // src={{Applogo} ? {Applogo} : {profileLogo}}
//                   src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYP-KKtRJXm9qK7k2_PA1utxbxWdpzGIdulQ&s'
//                   alt='mohit'
//                   className="img-fluid rounded-circle"
//                   style={{ width: '100px', height: '100px' }}
//                 />
//               </div>

//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch && allbranch.length>0 && allbranch.map((res)=>(
//                         <option value={res.id}>{res.name}</option>
//                        ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Customer Name <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.Name} onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <label className="col-form-label">Upload Document <span className="text-danger">*</span></label>
//                     <input
//                       className="form-control"
//                       type="file"
//                       accept="image/*"
//                       ref={fileInputRef}
//                       // value={LocalFormData.Selfie}
//                       onChange={handleFileChange}
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={LocalFormData.Mobile} onChange={handleMobileChange} />
//                     </div>
//                   </div>
//                   {/*
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Purpose <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.Purpose}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, Purpose: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         <option value="1">Hello</option>
//                         <option value="2">Branch 1</option>
//                         <option value="3">branch 2</option>

//                       </select>
//                     </div>
//                   </div> */}
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Application No.<span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.ApplicationNo} onChange={(e) => setLocalFormData({ ...LocalFormData, ApplicationNo: e.target.value })} />
//                     </div>
//                   </div>
//                   {/* <label className="col-form-label">
//                     Purpose Met<span className="text-danger">*</span>
//                   </label> */}

//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       Purpose Met <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         value="true"
//                         checked={LocalFormData.IsPurposeMet === true}
//                         onChange={(e)=>setLocalFormData({...LocalFormData,IsPurposeMet:e.target.value === "true"})}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault1">
//                         Yes
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault2"
//                         value=""
//                         checked={LocalFormData.IsPurposeMet === false}
//                         onChange={(e)=> setLocalFormData({...LocalFormData,IsPurposeMet:e.target.value === "true"})}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault2">
//                         No
//                       </label>
//                     </div>
//                   </div>

//                   {/* Conditional rendering based on radio selection */}
//                   {/* {radioValue === true ? (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Application Number <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           className="form-control"
//                           type="text"
//                           value={LocalFormData.ApplicationNo}
//                           onChange={(e) => setLocalFormData({ ...LocalFormData, ApplicationNo: e.target.value })}
//                         />
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Visit Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.VisitDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   )} */}
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>

//             </div>
//           </div>
//         </div>
//       </div>

//       <div id="edit_client" className="modal custom-modal fade" role="dialog">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Edit Client</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         First Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         defaultValue="Barry"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Last Name</label>
//                       <input
//                         className="form-control"
//                         defaultValue="Cuda"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Username <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Email <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control floating"
//                         defaultValue="barrycuda@example.com"
//                         type="email"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Password</label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="password"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Confirm Password</label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="password"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Client ID <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control floating"
//                         defaultValue="CLT-0001"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Phone </label>
//                       <input
//                         className="form-control"
//                         defaultValue={9876543210}
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Company Name</label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         defaultValue="Global Technologies"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="table-responsive m-t-15">
//                   <table className="table table-striped custom-table">
//                     <thead>
//                       <tr>
//                         <th>Module Permission</th>
//                         <th className="text-center">Read</th>
//                         <th className="text-center">Write</th>
//                         <th className="text-center">Create</th>
//                         <th className="text-center">Delete</th>
//                         <th className="text-center">Import</th>
//                         <th className="text-center">Export</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {tableData.map((row, index) => (
//                         <tr key={index}>
//                           <td>{row.module}</td>
//                           {[
//                             "read",
//                             "write",
//                             "create",
//                             "delete",
//                             "import",
//                             "export",
//                           ].map((column) => (
//                             <td key={column} className="text-center">
//                               <label className="custom_check">
//                                 <input
//                                   type="checkbox"
//                                   checked={row[column]}
//                                   onChange={() =>
//                                     handleCheckboxChange(row.module, column)
//                                   }
//                                 />
//                                 <span className="checkmark"></span>
//                               </label>
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="reset"
//                   >
//                     Save
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// Modal

import React, { useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../ToastComponent";
import { Api_Url } from "../../../config/config";
import { AllFormsUpperphoto } from "../../../Routes/ImagePath";

export const BTBankModal = ({ BTBankDataVisitFunc, onClose }) => {
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const [LocalFormData, setLocalFormData] = useState({
    BranchId: "",
    Name: "",
    Mobile: "",
    IsPurposeMet: false,
    ApplicationNo: "",
    Selfie: null,
    Latitude: "",
    Longitude: "",
  });

  const [allbranch, setAllBranch] = useState([]);

  const AllBranchName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setAllBranch(response.data.data);
    } catch (error) {
      console.log("Error fetching branches", error);
    }
  };

  useEffect(() => {
    AllBranchName();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setLocalFormData({ ...LocalFormData, Selfie: file });
  };

  // Function to validate mobile number
  const validateMobileNumber = (number) => {
    const regex = /^[0-9]{10}$/; // Exactly 10 digits
    return regex.test(number);
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 10) { // Allow only numeric values and limit length
      setLocalFormData({ ...LocalFormData, Mobile: value });
    }
  };

  const validateForm = () => {
    if (!LocalFormData.BranchId) {
      ErrorToast("Branch is required.");
      return false;
    }
    if (!LocalFormData.Name) {
      ErrorToast("Customer Name is required.");
      return false;
    }
    if (!LocalFormData.Mobile || !validateMobileNumber(LocalFormData.Mobile)) {
      ErrorToast("Valid Mobile Number (10 digits) is required.");
      return false;
    }
    if (!LocalFormData.ApplicationNo) {
      ErrorToast("Application No. is required.");
      return false;
    }
    if (!LocalFormData.Selfie) {
      ErrorToast("Upload Document is required.");
      return false;
    }
    return true;
  };

  const HandleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("BranchId", LocalFormData.BranchId);
    formData.append("Name", LocalFormData.Name);
    formData.append("Mobile", LocalFormData.Mobile);
    formData.append("IsPurposeMet", LocalFormData.IsPurposeMet);
    formData.append("ApplicationNo", LocalFormData.ApplicationNo);
    formData.append("Selfie", LocalFormData.Selfie);
    formData.append("Latitude", LocalFormData.Latitude);
    formData.append("Longitude", LocalFormData.Longitude);

    try {
      const response = await axios.post(
        `${Api_Url}api/v1/BTBankVisit`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      BTBankDataVisitFunc();
      resetForm();
      SuccessToast("BTBank Submitted Successfully");
      onClose();
    } catch (error) {
      ErrorToast("An Error Occurred while Submitting.");
      console.log("Submission error", error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setLocalFormData({
      BranchId: "",
      Name: "",
      Mobile: "",
      IsPurposeMet: false,
      ApplicationNo: "",
      Selfie: null,
      Latitude: "",
      Longitude: "",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <Modal
      title={<h4>BT Bank Visit</h4>}
      open={true}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <div className="d-flex justify-content-between align-items-center" key="footer">
          <button className="btn btn-danger submit-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary submit-btn"
            onClick={HandleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>,
      ]}
      width={600}
      maskClosable={false}
      closeIcon={<span style={{ color: "red" }}>X</span>}
    >
      <div className="modal-body mt-5">
        <div className="profile-image text-center mt-4 mb-4">
          <img
            src={AllFormsUpperphoto}
            alt="Profile"
            className="img-fluid rounded-circle"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
        <form>
          <div className="row">
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Branch <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={LocalFormData.BranchId}
                  onChange={(e) =>
                    setLocalFormData({ ...LocalFormData, BranchId: e.target.value })
                  }
                >
                  <option value="">Select Branch</option>
                  {allbranch &&
                    allbranch.length > 0 &&
                    allbranch.map((res) => (
                      <option key={res.id} value={res.id}>
                        {res.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Customer Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={LocalFormData.Name}
                  onChange={(e) =>
                    setLocalFormData({ ...LocalFormData, Name: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="col-md-6">
              <label className="col-form-label">
                Upload Document <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleFileChange}
              />
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Mobile <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text" // Change to text to handle length restrictions
                  value={LocalFormData.Mobile}
                  onChange={handleMobileChange}
                  maxLength={10} // Limit input length to 10
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Application No.<span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={LocalFormData.ApplicationNo}
                  onChange={(e) =>
                    setLocalFormData({ ...LocalFormData, ApplicationNo: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="col-md-12">
              <label className="col-form-label">
                Purpose Met <span className="text-danger">*</span>
              </label>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  value="true"
                  checked={LocalFormData.IsPurposeMet === true}
                  onChange={(e) =>
                    setLocalFormData({ ...LocalFormData, IsPurposeMet: e.target.value === "true" })
                  }
                />
                <label className="form-check-label" htmlFor="flexRadioDefault1">
                  Yes
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault2"
                  value="false"
                  checked={LocalFormData.IsPurposeMet === false}
                  onChange={(e) =>
                    setLocalFormData({ ...LocalFormData, IsPurposeMet: e.target.value === "true" })
                  }
                />
                <label className="form-check-label" htmlFor="flexRadioDefault2">
                  No
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};



{
  /* <div className="col-md-12">
<label className="col-form-label">
    File Logged In <span className="text-danger">*</span>
</label>
<div className="form-check">
    <input
        className="form-check-input"
        type="radio"
        name="flexRadioDefault"
        id="flexRadioDefault1"
        value="true"
        checked={radioValue === true}
        onChange={handleRadioChange}
    />
    <label className="form-check-label" htmlFor="flexRadioDefault1">
        Yes
    </label>
</div>
<div className="form-check">
    <input
        className="form-check-input"
        type="radio"
        name="flexRadioDefault"
        id="flexRadioDefault2"
        value="false"
        checked={radioValue === false}
        onChange={handleRadioChange}
    />
    <label className="form-check-label" htmlFor="flexRadioDefault2">
        No
    </label>
</div>
</div> */
}

{
  /* Conditional rendering based on radio selection */
}
// {radioValue === true ? (
// <div className="col-md-6">
//     <div className="input-block mb-3">
//         <label className="col-form-label">
//             Application Number <span className="text-danger">*</span>
//         </label>
//         <input
//             className="form-control"
//             type="text"
//             value={localFormData.ApplicationNo}
//             onChange={(e) => setLocalFormData({ ...localFormData, ApplicationNo: e.target.value })}
//         />
//     </div>
// </div>
// ) : (
// <div className="col-md-6">
//     <div className="input-block mb-3">
//         <label className="col-form-label">
//             Visit Date <span className="text-danger">*</span>
//         </label>
//         <DatePicker
//             selected={localFormData.VisitDate}
//             onChange={handleDateChange}
//             className="form-control"
//             minDate={new Date()}
//         />
//     </div>
// </div>
// )}

// import React, { useEffect, useState } from "react";
// import { Applogo, profileLogo } from "../../../Routes/ImagePath";
// import { DatePicker } from "antd";
// import { Radio } from "react-feather";
// import { useNavigate } from "react-router-dom";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";

// export const BankModalAddpopup = () => {
//   const initialTableData = [
//     {
//       module: "Projects",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Tasks",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Chat",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Estimates",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Invoices",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Timing Sheets",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//   ];

//   //   let yourDate = new Date()
//   // // yourDate.toISOString().split('T')[0]

//   // const today=(yourDate.toISOString().split('T')[0])

//   const [tableData, setTableData] = useState(initialTableData)

//   // const [userId,setUserId] = useState('')

//   // useEffect(() => {
//   //  const id= JSON.parse(sessionStorage.getItem('user'))
//   // setUserId(id)
//   // }, [])

//   const AllFileLoginData = async () => {
//     try {
//       const id = JSON.parse(sessionStorage.getItem('user'))?.id
//       console.log("id", id)
//       const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       console.log("response", response)
//     } catch (error) {
//       return error
//     }
//   }

//   useEffect(() => {
//     AllFileLoginData()
//   }, [])

//   const [radioValue, setRadioValue] = useState(false);

//   // const [location, setLocation] = useState(null);

//   const [LocalFormData, setLocalFormData] = useState({

//     BranchId: "",
//     Name: "",
//     Mobile: "",
//     ApplicationNo: "",
//     IsFileLoggedIn: radioValue,
//     ExpectedDate: new Date(),
//     Latitude: "",
//     Longitude: "",
//   });

//   const handleRadioChange = (e) => {
//     setRadioValue(e.target.value === 'true');

//   };

//   const handleDateChange = (date) => {
//     setLocalFormData({ ...LocalFormData, VisitDate: date });
//   };

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {

//         const { latitude, longitude } = position.coords;
//         setLocalFormData({ ...LocalFormData, Latitude: latitude, Longitude: longitude });
//       });
//     } else {
//       console.log("Geolocation is not supported by this browser.");
//     }
//   }, [])

//   // console.log("location",location?.latitude)

//   const HandleSubmit = () => {
//     console.log(LocalFormData)
//   }

//   const handleCheckboxChange = (module, column) => {
//     // Create a copy of the tableData
//     const updatedTableData = [...tableData];

//     // Find the row with the specified module
//     const row = updatedTableData.find((item) => item.module === module);

//     // Toggle the checkbox value
//     row[column] = !row[column];

//     // Set the updated data
//     setTableData(updatedTableData);
//   };

//   return (
//     <>
//       <div id="add_client" className="modal custom-modal fade" role="dialog">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">File Login</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="profile-image text-center mt-4 mb-4">
//                 <img
//                   // src={{Applogo} ? {Applogo} : {profileLogo}}
//                   src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYP-KKtRJXm9qK7k2_PA1utxbxWdpzGIdulQ&s'
//                   alt='mohit'
//                   className="img-fluid rounded-circle"
//                   style={{ width: '100px', height: '100px' }}
//                 />
//               </div>

//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         <option value="branch1">Hello</option>
//                         <option value="branch2">Branch 1</option>
//                         <option value="branch3">branch 2</option>
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Customer Name <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.Name} onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={LocalFormData.Mobile} onChange={(e) => setLocalFormData({ ...LocalFormData, Mobile: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         <option value="branch1">Hello</option>
//                         <option value="branch2">Branch 1</option>
//                         <option value="branch3">branch 2</option>
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   {/* <label className="col-form-label">
//                     Purpose Met<span className="text-danger">*</span>
//                   </label> */}

//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       Purpose Met <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         // value="true"
//                         // checked={radioValue === true}
//                         // onChange={handleRadioChange}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault1">
//                         Yes
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault2"
//                         // value=""
//                         // checked={radioValue === false}
//                         // onChange={handleRadioChange}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault2">
//                         No
//                       </label>
//                     </div>
//                   </div>

//                   {/* Conditional rendering based on radio selection */}
//                   {/* {radioValue === true ? (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Application Number <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           className="form-control"
//                           type="text"
//                           value={LocalFormData.ApplicationNo}
//                           onChange={(e) => setLocalFormData({ ...LocalFormData, ApplicationNo: e.target.value })}
//                         />
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Visit Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.VisitDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   )} */}
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>

//             </div>
//           </div>
//         </div>
//       </div>

//       <div id="edit_client" className="modal custom-modal fade" role="dialog">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Edit Client</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         First Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         defaultValue="Barry"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Last Name</label>
//                       <input
//                         className="form-control"
//                         defaultValue="Cuda"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Username <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Email <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control floating"
//                         defaultValue="barrycuda@example.com"
//                         type="email"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Password</label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="password"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Confirm Password</label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="password"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Client ID <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control floating"
//                         defaultValue="CLT-0001"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Phone </label>
//                       <input
//                         className="form-control"
//                         defaultValue={9876543210}
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Company Name</label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         defaultValue="Global Technologies"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="table-responsive m-t-15">
//                   <table className="table table-striped custom-table">
//                     <thead>
//                       <tr>
//                         <th>Module Permission</th>
//                         <th className="text-center">Read</th>
//                         <th className="text-center">Write</th>
//                         <th className="text-center">Create</th>
//                         <th className="text-center">Delete</th>
//                         <th className="text-center">Import</th>
//                         <th className="text-center">Export</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {tableData.map((row, index) => (
//                         <tr key={index}>
//                           <td>{row.module}</td>
//                           {[
//                             "read",
//                             "write",
//                             "create",
//                             "delete",
//                             "import",
//                             "export",
//                           ].map((column) => (
//                             <td key={column} className="text-center">
//                               <label className="custom_check">
//                                 <input
//                                   type="checkbox"
//                                   checked={row[column]}
//                                   onChange={() =>
//                                     handleCheckboxChange(row.module, column)
//                                   }
//                                 />
//                                 <span className="checkmark"></span>
//                               </label>
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="reset"
//                   >
//                     Save
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// {/* <div className="col-md-12">
// <label className="col-form-label">
//     File Logged In <span className="text-danger">*</span>
// </label>
// <div className="form-check">
//     <input
//         className="form-check-input"
//         type="radio"
//         name="flexRadioDefault"
//         id="flexRadioDefault1"
//         value="true"
//         checked={radioValue === true}
//         onChange={handleRadioChange}
//     />
//     <label className="form-check-label" htmlFor="flexRadioDefault1">
//         Yes
//     </label>
// </div>
// <div className="form-check">
//     <input
//         className="form-check-input"
//         type="radio"
//         name="flexRadioDefault"
//         id="flexRadioDefault2"
//         value="false"
//         checked={radioValue === false}
//         onChange={handleRadioChange}
//     />
//     <label className="form-check-label" htmlFor="flexRadioDefault2">
//         No
//     </label>
// </div>
// </div> */}

// {/* Conditional rendering based on radio selection */ }
// // {radioValue === true ? (
// // <div className="col-md-6">
// //     <div className="input-block mb-3">
// //         <label className="col-form-label">
// //             Application Number <span className="text-danger">*</span>
// //         </label>
// //         <input
// //             className="form-control"
// //             type="text"
// //             value={localFormData.ApplicationNo}
// //             onChange={(e) => setLocalFormData({ ...localFormData, ApplicationNo: e.target.value })}
// //         />
// //     </div>
// // </div>
// // ) : (
// // <div className="col-md-6">
// //     <div className="input-block mb-3">
// //         <label className="col-form-label">
// //             Visit Date <span className="text-danger">*</span>
// //         </label>
// //         <DatePicker
// //             selected={localFormData.VisitDate}
// //             onChange={handleDateChange}
// //             className="form-control"
// //             minDate={new Date()}
// //         />
// //     </div>
// // </div>
// // )}
